import { render, staticRenderFns } from "./welPage.vue?vue&type=template&id=28316042&scoped=true"
import script from "./welPage.vue?vue&type=script&lang=js"
export * from "./welPage.vue?vue&type=script&lang=js"
import style0 from "./welPage.vue?vue&type=style&index=0&id=28316042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28316042",
  null
  
)

export default component.exports